import { Box, useMediaQuery } from '@mui/material';
import Search from './Search';
import Profile from './Profile';
import useRealTimeClock from 'hooks/useRealTimeClock';

const HeaderContent = () => {
  const { time, timeData, todayTimeLoading } = useRealTimeClock();

  const matchesXs = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <>
      {!matchesXs && <Search />}
      {matchesXs && <Box sx={{ width: '100%', ml: 1 }} />}

      <div className="flex justify-end pb-1 mr-[3vw]">
        <div className="bg-gradient-to-r from-indigo-600 via-blue-500 to-purple-600 text-white pb-1 pt-1 px-3 rounded-[0.4rem] text-center min-w-[200px] shadow-md border border-gray-700">

          {todayTimeLoading ? (
            // 🔄 Loader Spinner
            <div className="flex justify-center items-center h-[45px]">
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <>
              {/* Time */}
              <p className="text-[0.95rem] font-bold tracking-widest">
                {time?.toLocaleTimeString()}
              </p>

              {/* Date */}
              <p className="text-[0.75rem] text-gray-200 font-medium">
                {time?.toLocaleDateString(undefined, {
                  weekday: "short",
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </>
          )}

        </div>
      </div>

      <Profile />
    </>
  );
};

export default HeaderContent;